import { render, staticRenderFns } from "./playerThisSeasonRecord.vue?vue&type=template&id=7cf52d5b&scoped=true"
import script from "./playerThisSeasonRecord.vue?vue&type=script&lang=js"
export * from "./playerThisSeasonRecord.vue?vue&type=script&lang=js"
import style0 from "./playerThisSeasonRecord.vue?vue&type=style&index=0&id=7cf52d5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf52d5b",
  null
  
)

export default component.exports